module.exports = __webpack_public_path__ + "static/hero-2-3386e2bf71f90acd301c94f97fe11189.jpg";